import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import { Table } from 'antd';
import { PageContainer } from '@ant-design/pro-layout';

const withRouter = (WrappedComponent) => {
  return (props) => {
    const navigate = useNavigate();
    return <WrappedComponent {...props} navigate={navigate} />;
  };
};

class SubMerchs extends Component {
  constructor(props) {
    super(props);
    this.state = {
      merchs: [],
      subUser: null,
      loading: false,
      columns: [
        {
          title: 'Numara Tipi',
          dataIndex: 'type',
          key: 'type',
        },
        {
          title: 'Numara',
          dataIndex: 'number',
          key: 'number',
        },
        {
          title: 'İletişim Adı',
          dataIndex: 'contactName',
          key: 'contanctName',
        },
        {
          title: 'İletişim Maili',
          dataIndex: 'contactEmail',
          key: 'contanctEmail',
        },
        {
          title: 'İletişim Numarası',
          dataIndex: 'contactGsm',
          key: 'contanctGsm',
        },
        {
          title: 'Arşiv Maili',
          dataIndex: 'emailForArchive',
          key: 'emailForArchive',
        },
        // {
        //   title: 'İşlemler',
        //   dataIndex: 'identifier',
        //   key: 'actions',
        //   fixed: 'right',
        //   width: 100,
        //   render: (id, record) => (
        //     <div>
        //       <Button
        //         type="ghost"
        //         onClick={() => {
        //           console.log(record)
        //         }}
        //       >
        //         <Icon type="edit" />
        //       </Button>
        //     </div>
        //   )
        // },
      ],
    };
  }

  componentDidMount() {
    const { location } = this.props;
    const { state } = location;
    this.setState({ merchs: state?.record?.merchantInfos, subUser: state?.record });
  }

  render() {
    const { merchs, columns, loading, subUser } = this.state;
    const { navigate } = this.props;

    return (
      <PageContainer
        title="Üye İşyeri İşlemleri"
        subTitle={`"${subUser?.email}" kullanıcısına ait üye işyerleri listelenmektedir.`}
        onBack={() => navigate(-1)}
        // extra={[
        //   <Button disabled={loading} key="1" type="primary" icon="plus" onClick={() => { this.handleOpenForm() }}>
        //     Ekle
        //   </Button>,
        // ]}
      >
        <Table
          loading={loading}
          dataSource={merchs}
          columns={columns}
          pagination={false}
          rowKey="identifier"
        />
      </PageContainer>
    );
  }
}

SubMerchs.propTypes = {
  location: PropTypes.shape({
    state: PropTypes.shape({
      record: PropTypes.shape({
        merchantInfos: PropTypes.arrayOf(
          PropTypes.shape({
            type: PropTypes.string,
            number: PropTypes.string,
            contactName: PropTypes.string,
            contactEmail: PropTypes.string,
            contactGsm: PropTypes.string,
            emailForArchive: PropTypes.string,
          }),
        ),
        email: PropTypes.string,
      }),
    }),
  }).isRequired,
  navigate: PropTypes.func.isRequired,
};

export default withRouter(SubMerchs);
